export default __webpack_public_path__ + "static/media/logo-white-desktop.5b7097f9.svg";